export enum UserRoleEnum {
  AdministratorOfEnterprise = 'b0000001-0000-0000-0000-000000000001',
  AdministratorOfPractice   = 'b0000001-0000-0000-0000-000000000002',
  Configuration             = 'b0000001-0000-0000-0000-000000000003',
  Insurance                 = 'b0000001-0000-0000-0000-000000000004',
  InsuranceViewOnly         = 'b0000001-0000-0000-0000-000000000005',
  Scheduler                 = 'b0000001-0000-0000-0000-000000000006',
  InsuranceClaimsMgmt       = 'b0000001-0000-0000-0000-000000000007',
  Communications            = 'b0000001-0000-0000-0000-000000000008',
  Notes                     = 'b0000001-0000-0000-0000-000000000009',
  NotesViewOnly             = 'b0000001-0000-0000-0000-000000000010',
  Letters                   = 'b0000001-0000-0000-0000-000000000011',
  Fees                      = 'b0000001-0000-0000-0000-000000000012',
  Ledger                    = 'b0000001-0000-0000-0000-000000000013',
  ImageOrganizer            = 'b0000001-0000-0000-0000-000000000014',
  CaseMgmt                  = 'b0000001-0000-0000-0000-000000000015',
  CaseMgmtViewOnly          = 'b0000001-0000-0000-0000-000000000016',
  ImagingStudio             = 'b0000001-0000-0000-0000-000000000017',
  ImagingCenter             = 'b0000001-0000-0000-0000-000000000018',
  Erx                       = 'b0000001-0000-0000-0000-000000000019',
  TreatmentPlanning         = 'b0000001-0000-0000-0000-000000000020',
  VisitWizard               = 'b0000001-0000-0000-0000-000000000021',
  PaymentAudit              = 'b0000001-0000-0000-0000-000000000022',
  PaymentFromInsurance      = 'b0000001-0000-0000-0000-000000000023',
  PaymentFromPatient        = 'b0000001-0000-0000-0000-000000000024',
  NoteToFront               = 'b0000001-0000-0000-0000-000000000025',
  eRxAdmin                  = 'b0000001-0000-0000-0000-000000000026',
  Reports                   = 'b0000001-0000-0000-0000-000000000027',
  Enterprise                = 'b0000001-0000-0000-0000-000000000028',
  EnterpriseAnalysis        = 'b0000001-0000-0000-0000-000000000029'
}
